export default __webpack_public_path__ + "static/media/keto_concentration@3x.3dafa7c5.jpg";